import React, { useState } from "react";
import { useDispatch } from "react-redux";
import SkuCategoriesTable from "../components/sku-categories-table";
import type { CommissionSkuCategoryValue } from "../types/commissions.types";
import {
  useGetSkuCategoriesQuery,
  useUpdateCommissionSkuCategoryMutation,
} from "../endpoints/commissions.endpoints";
import { portalDs } from "src/components/portal-design-system/portal-ds-classes";
import notificationService from "src/services/notification/notification.service";

const SkuCategoriesView: React.FC = () => {
  const dispatch = useDispatch();
  const { data: skus = [] } = useGetSkuCategoriesQuery();
  const [updateCategory] = useUpdateCommissionSkuCategoryMutation();
  const [savingId, setSavingId] = useState<string | null>(null);

  const handleCategoryChange = async (
    skuId: string,
    category: CommissionSkuCategoryValue
  ) => {
    setSavingId(skuId);
    try {
      await updateCategory({ id: skuId, category }).unwrap();
    } catch (error) {
      notificationService.handleError(
        error,
        dispatch,
        "Failed to update SKU category"
      );
    } finally {
      setSavingId(null);
    }
  };

  return (
    <div className="space-y-4">
      <p className={portalDs.bodySm}>
        Tag each QuickBooks SKU with a commission category. Excluded categories are dropped from Activation Team payout calculations.
      </p>
      <SkuCategoriesTable
        skus={skus}
        onCategoryChange={handleCategoryChange}
        savingId={savingId}
      />
    </div>
  );
};

export default SkuCategoriesView;
